module.exports = __webpack_public_path__ + "img/logo-sub-console.7fa83c63.svg";